import axios from 'axios';

/**
 * Make a GET request to dashboard API with base URL and auth token (same pattern as existing views).
 * @param {string} baseApi - Base API URL (e.g. process.env.VUE_APP_APIENDPOINT)
 * @param {string} accessToken - Bearer token
 * @param {string} path - API path (e.g. '/dashboard/crm/realtime-kpi')
 * @param {object} params - Query params
 * @returns {Promise}
 */
export function dashboardGet(baseApi, accessToken, path, params = {}) {
  const url = `${baseApi}${path}`;
  return axios.get(url, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
}
